import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
} from "firebase/auth";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { auth } from "../../firebase";
import { useNavigate } from "react-router-dom";
import Alert from "react-bootstrap/Alert";
import "./auth.css";

const initialState = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  confirmPassword: "",
};

const Auth = ({ setActive, setUser }) => {
  const [state, setState] = useState(initialState);
  const [signUp, setSignUp] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [alertText, setAlertText] = useState("");

  const { email, password, firstName, lastName, confirmPassword } = state;

  const navigate = useNavigate();

  React.useEffect(() => {
    document.title = signUp
      ? "Sign Up - youvaraj.com"
      : "Sign In - youvaraj.com";
  }, [signUp]);

  const onCloseAlert = () => {
    setAlertText("");
  };

  const handleChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const handleAuth = async (e) => {
    e.preventDefault();
    if (!signUp) {
      if (email && password) {
        const { user } = await signInWithEmailAndPassword(
          auth,
          email,
          password
        );
        setUser(user);
        setActive("home");
      } else {
        setErrorAlert(true);
        setAlertText("All fields are required");

        return toast.error("All fields are mandatory to fill");
      }
    } else {
      if (password !== confirmPassword) {
        setErrorAlert(true);
        setAlertText(`Password don't match`);
        return toast.error("Password don't match");
      }
      if (firstName && lastName && email && password) {
        const user = await createUserWithEmailAndPassword(
          auth,
          email,
          password
        ).catch((error) => {
          console.log("Error creating user", error);
        });
        if (user !== undefined) {
          await updateProfile(user, {
            displayName: `${firstName} ${lastName}`,
          });
          setActive("home");
        }

        setErrorAlert(true);

        setAlertText("Email already exists.");
        return toast.error("Email already exist.");
      } else {
        setAlertText("All fields are required");
        return toast.error("All fields are mandatory to fill");
      }
    }
    navigate("/");
  };

  return (
    <div className="auth-page">
      <div className="container">
        <div className="page-title-header">
          <h1 className="page-title">{!signUp ? "Sign In" : "Sign Up"}</h1>
        </div>

        <div className="auth-container">
          <div className="auth-card">
            {alertText && (
              <Alert
                variant={errorAlert ? "danger" : "success"}
                className="auth-alert"
                onClose={onCloseAlert}
                dismissible
              >
                {alertText}
              </Alert>
            )}

            <form className="auth-form" onSubmit={handleAuth}>
              {signUp && (
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="firstName">First Name</label>
                    <input
                      id="firstName"
                      type="text"
                      className="form-input"
                      placeholder="Enter your first name"
                      name="firstName"
                      value={firstName}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="lastName">Last Name</label>
                    <input
                      id="lastName"
                      type="text"
                      className="form-input"
                      placeholder="Enter your last name"
                      name="lastName"
                      value={lastName}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              )}

              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  type="email"
                  className="form-input"
                  placeholder="Enter your email"
                  name="email"
                  value={email}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  id="password"
                  type="password"
                  className="form-input"
                  placeholder="Enter your password"
                  name="password"
                  value={password}
                  onChange={handleChange}
                />
              </div>

              {signUp && (
                <div className="form-group">
                  <label htmlFor="confirmPassword">Confirm Password</label>
                  <input
                    id="confirmPassword"
                    type="password"
                    className="form-input"
                    placeholder="Confirm your password"
                    name="confirmPassword"
                    value={confirmPassword}
                    onChange={handleChange}
                  />
                </div>
              )}

              <button className="auth-submit-btn" type="submit">
                {!signUp ? "Sign In" : "Create Account"}
              </button>
            </form>

            <div className="auth-toggle">
              {!signUp ? (
                <p>
                  Don't have an account?{" "}
                  <span className="auth-link" onClick={() => setSignUp(true)}>
                    Sign Up
                  </span>
                </p>
              ) : (
                <p>
                  Already have an account?{" "}
                  <span className="auth-link" onClick={() => setSignUp(false)}>
                    Sign In
                  </span>
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Auth;
